module.exports = __webpack_public_path__ + "img/icon-account-circle-grey.76b343c6.svg";